import {
  Connectivity,
  ConnectivityType,
  DeviceStatus,
  NetworkType,
  PairingStatus,
  StbInterface,
  YesNoOption,
} from './enums';
import { KuxEventWithParam } from './events';

export class LowFrequencyHeartBeatEventArgs extends KuxEventWithParam {
  // @ts-expect-error TODO Fix
  status: DeviceStatus;
  /**
   * Status of the underlying backend service
   */
  // @ts-expect-error TODO Fix
  backendConnectivity: Connectivity;
  /**
   * STB interfaces is use
   */
  interface?: StbInterface;
  /**
   * In case of HDMI interface being used, the HDMI version.
   * only in STB
   */
  hdmiVersion?: string;
  /**
   * In case separate audio out is used, this should be specified.
   * only in STB
   */
  separateAudio?: YesNoOption;
  /**
   * Network currently being used.
   * all but WEB
   */
  networkInUse?: NetworkType;
  /**
   * Specify the connectivity method
   * only in STB and CTV
   */
  connectivity?: ConnectivityType;
  /**
   * Remote control pairing status with the STB
   * only in STB
   */
  rcPairingStatus?: PairingStatus;
  /**
   * EPOC timestamp since when the device is up
   * only in STB
   */
  upSince?: number;

  constructor(data: LowFrequencyHeartBeatEventArgs) {
    super('lowFrequencyHeartbeat', data as KuxEventWithParam);
    Object.assign(this, data);
  }
}
